// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"dea1803b","453":"d69f4579","498":"4bfdf0e2","551":"85d5ac31"}[chunkId] + ".chunk.js";
};